import {i18n} from '../plugins/i18n'

const state = {
    user: {},
    token: null,
    company: {},
    stage: {},
    role:{},
    period:{},
    sector:{},
    sectors:[], // Array de setores aos quais o usuário tem acesso
    roles: [],
    leadership:{},
    objective:{},
    stereotypes:{},
    menu:[],
    filteredMenu:[], // Menu filtrado por role e setor
    periods:[],
    sectores:[],
    assessments:[],
    periodsSlave: [],
    periodMaster: [],
    periodSlave: {},
    stageSlave: {},
    perspectives: []
}

const mutations = {
      populateUser(base, userDB){
        if (userDB == null) return;

        base.user = {
            id: userDB.id,
            name: userDB.name,
            email: userDB.email,
            username: userDB.username,
        }

        const userCompany = userDB.userCompanies.find(uc => uc.id === parseInt(localStorage.getItem('adv-user-company'))) || userDB.userCompanies[0];
        localStorage.setItem('adv-user-company', userCompany.id);
        base.company = userCompany.company;
        
        // stage
        // 1. Prioriza localStorage
        let stage = userCompany.company.stages.find(st => st.id === parseInt(localStorage.getItem('adv-stage')));
        
        // 2. Se não encontrou no localStorage, busca stage ativo (state === '1') que contenha o ano atual
        if (!stage) {
            const currentYear = new Date().getFullYear();
            
            // Busca stage com state === '1' que tenha dateStart no ano atual
            stage = userCompany.company.stages.find(st => {
                if (!st.dateStart || st.state !== '1') return false;
                const stageYear = new Date(st.dateStart).getFullYear();
                return stageYear === currentYear;
            });
            
            // 3. Se não encontrar com ano atual, busca o stage ativo mais recente (por dateStart)
            if (!stage) {
                const activeStages = userCompany.company.stages
                    .filter(st => st.state === '1' && st.dateStart)
                    .sort((a, b) => new Date(b.dateStart) - new Date(a.dateStart)); // Ordena do mais recente para o mais antigo
                
                stage = activeStages[0]; // Pega o mais recente
            }
            
            // 4. Se ainda não encontrou stage ativo, tenta qualquer stage com state === '1' (mesmo sem dateStart)
            if (!stage) {
                stage = userCompany.company.stages.find(st => st.state === '1');
            }
            
            // 4. Fallback para o primeiro stage disponível
            if (!stage) {
                stage = userCompany.company.stages[0];
            }
        }
        
        localStorage.setItem('adv-stage', stage.id);
        base.stage = stage;
        base.perspectives = stage.perspectives;
        base.stereotypes = stage.stereotypes;

        // period - LÓGICA MEJORADA PARA PERÍODO ACTUAL
        base.periods = stage.periods.sort((a, b) => (a.sorter || 0) - (b.sorter || 0));
        
        const today = new Date();
        let period = null;
        
        // Buscar período que contenga la fecha actual
        period = stage.periods.find(p => {
            if (!p.dateStart || !p.dateFinish) return false;
            const start = new Date(p.dateStart);
            const finish = new Date(p.dateFinish);
            return start <= today && finish >= today;
        });

        // Si no se encontró período actual, usar la lógica existente
        if (!period) {
            period = stage.periods.find(a => a.id === parseInt(localStorage.getItem("adv-period"))) 
                   || stage.periods.find(a => a.active) 
                   || stage.periods[0];
        }

        localStorage.setItem('adv-period', period.id);
        base.period = period;


        // roles
        base.roles = [];
        userCompany.roles.forEach(r => {
            base.roles.push(r.role);
        })

        const role = base.roles.find(r => r.id === parseInt(localStorage.getItem("adv-role"))) || base.roles[0];
        localStorage.setItem("adv-role", role.id);
        base.role = role;

        // sectors - Armazena todos os setores do stage atual
        base.sectors = userCompany.sectors
            .filter(a => a.stageId === stage.id)
            .map(s => s.sector) || [];
        
        // sector - Setor atual com validação de localStorage
        const savedSectorId = parseInt(localStorage.getItem("adv-sector"));
        let selectedSector = null;
        
        // Validar se o setor salvo ainda está acessível
        if (savedSectorId) {
            selectedSector = base.sectors.find(s => s.id === savedSectorId);
            if (!selectedSector) {
                // console.warn('Setor salvo no localStorage não está mais acessível:', savedSectorId);
                localStorage.removeItem("adv-sector");
            }
        }
        
        // Usar setor validado ou primeiro disponível
        base.sector = selectedSector || base.sectors[0] || {};
        
        // Salvar setor válido
        if(base.sector.id) {
            localStorage.setItem("adv-sector", base.sector.id);
        }



        /*const {companies} = userDB;
        
        let {stages, ...companyData} = companies.find(x => x.state === '1')
        if(localStorage.getItem("adv-company")){
            let tempInfo = companies.find(x => x.id + '' === localStorage.getItem("adv-company"))
            if(tempInfo){
                stages = tempInfo.stages;
                companyData = tempInfo; 
            }
        }
        let currentStage = stages.find(x => x.state === '1');
        if( localStorage.getItem("adv-stage")){
            stages.forEach(s => {
                if(s.id + '' === localStorage.getItem("adv-stage")){
                    currentStage = s;
                }
            })
        }
        //console.log(currentStage);
        //const {sectors, ...stageData} = localStorage.getItem("adv-stage") ? stages.find(x => x.id + '' === localStorage.getItem("adv-stage")) || stages.find(x => x.state === '1') : stages.find(x => x.state === '1')
        const {sectors, ...stageData} = currentStage
        //const {roles} = companies.find(x => x.state === '1')
        //const {periods} = currentStage;
        const {groups} = currentStage;
        const {sectores} = currentStage;


        //localStorage.setItem("hope", userBD.token);
        base.user = userData;
        base.company = companyData;
        base.stage = stageData;
        base.groups = groups;
        base.role = localStorage.getItem("adv-role") ? roles.find(x => x.id + '' === localStorage.getItem("adv-role")) || roles.find(x => x.state === '1') : roles.find(x => x.state === '1')
        //base.period = localStorage.getItem("adv-period") ? periods.find(x => x.id + '' === localStorage.getItem("adv-period")) || periods.find(x => x.state === '1') : periods.find(x => x.state === '1')
        base.period = periods.find(x => x.state === '1')
        if( localStorage.getItem("adv-period")){
            periods.forEach(p => {
                if(p.id + '' === localStorage.getItem("adv-period") + ''){
                    base.period = p; 
                }
            })
        }*/
        
        //base.sector = sectors.find(x => x.state === '1')
        //base.leadership = base.sector.leadership;
        //base.stereotypes = stageData.stereotypes;
        //base.periods = periods;

        //base.sectores = sectores;

        base.menu = [
            {id: 7, name: i18n.t('menu.operational'), icon:'mdi-sitemap', path :'/app/indicadores-stereotype'},
            {id: 13, name: i18n.t('menu.tactic'), icon:'mdi-human-capacity-increase', path :'/app/kpi-analysis'},
            {id: 14, name: i18n.t('menu.strategic'), icon:'mdi-human-capacity-increase', path :'/app/kpi-manager'},
            //{id: 8, name: 'Gerencia', icon:'mdi-monitor-dashboard', path :'/app/ceo'},
            {id: 9, name: i18n.t('menu.plan'), icon:'mdi-file-table', path :'/app/feedback'},
            //{id: 15, name:  i18n.t('menu.process'), icon:'mdi-cog-clockwise', path :'/app/process'},
            {id: 10, name:  i18n.t('menu.map'), icon:'mdi-map', path :'/app/map'},
            {id: 11, name:  i18n.t('menu.risk'), icon:'mdi-flag', path :'/app/riesgo'},
            {id: 12, name:  i18n.t('menu.ose'), icon:'mdi-poll', path :'/app/ose'},
            {id: 16, name:  i18n.t('menu.epr'), icon:'mdi-file', path :'/app/epr'},
            {id: 17, name:  i18n.t('menu.checklist'), icon:'mdi-check-all', path :'/app/checklist'},
            {id: 1, name: i18n.t('menu.advance'), icon:'mdi-counter', path :'/app/avances'},
           // {id: 2, name: 'Indicadores 1', icon:'mdi-monitor-dashboard', path :'/app/kpi'},
            {id: 3, name:  i18n.t('menu.review'), icon:'mdi-check', path: '/app/evaluar'},
            {id: 4, name:  i18n.t('menu.agreement'), icon:'mdi-clipboard-check-multiple', path: '/app/acuerdos'},
            {id: 5, name:  i18n.t('menu.report'), icon:'mdi-file-document-multiple', path :'/app/reportes'},
            {id: 6, name:  i18n.t('menu.config'), icon:'mdi-tools', path :'/app/configuraciones'},
        ]

        
        /*localStorage.setItem("adv-period", base.period.id)
        localStorage.setItem("adv-stage", base.stage.id)
        localStorage.setItem("adv-role", base.role.id)
        localStorage.setItem("adv-company", base.company.id)
        */
    },

    logOut(base){
        localStorage.removeItem("hope");
        localStorage.removeItem("adv-period")
        localStorage.removeItem("adv-stage")
        localStorage.removeItem("adv-role")
        base.user =  {}
        base.token =  null
        base.company =  {}
        base.stage =  {}
        base.role = {}
        base.period = {}
        base.sector = {}
        base.leadership = {}
        base.objective = {}
    },
    setPeriod(base, period){
        localStorage.setItem("adv-period", period.id)
        base.period = period;
    },
    setPeriods(base, periods){
        base.periods = periods;
    },
    setStage(base, stage){
        base.stereotypes = stage.stereotypes;
        base.perspectives = stage.perspectives;
        localStorage.setItem("adv-stage", stage.id)
        base.stage = stage;
    },
    setSector(base, sector){
        base.sector = sector;
        if(sector.id) {
            localStorage.setItem("adv-sector", sector.id);
        }
        // Limpa o menu filtrado para forçar recalculo
        base.filteredMenu = [];
    },
    setSectors(base, sectors){
        base.sectors = sectors || [];
    },
    setRole(base, role){
        localStorage.setItem("adv-role", role.id)
        base.role = role;
        // Limpa o menu filtrado para forçar recalculo
        base.filteredMenu = [];
    },
    setAssessments(base, data){
        base.assessments = data;
    },
    setStageSlave(base, stage){
        base.stageSlave = stage;
    },
    setPeriodsSlave(base, periods){
        base.periodsSlave = periods;
        base.periodSlave = periods.at(0) || {}
    },
    changePeriodSlave(period){
        base.periodSlave = period
    },
    setFilteredMenu(base, menu){
        base.filteredMenu = menu;
    }

}

const getters = {
    isLogin(base){
        if(base.user.id){
            return true;
        }return false;
    },
    periodId(base){
        if(base.period){
            return base.period.id;
        }return '';
    },
    periodEnable(base){
        if(base.period){
            return base.period.active;
        }return false;
    },
    // Getters para setores
    getCurrentSector: (state) => state.sector,
    getAllSectors: (state) => state.sectors,
    hasMultipleSectors: (state) => state.sectors.length > 1,
    hasSectorAccess: (state) => (sectorId) => {
        return state.sectors.some(s => s.id === sectorId);
    },
    getMenu(base){
        // Retorna o menu já filtrado por role e setor
        // Se ainda não foi filtrado, retorna as opções da role
        return base.filteredMenu.length > 0 ? base.filteredMenu : (base.role.options || []);
        /*
        //const comun = [7,9,8,4,5,1,11,12, 13, 15];
        const comun = [4,7,9,8,5,1, 13, 15];
        const controller = [1,3];
        const feedback = [1,3]
        const quality = [7,1,4,5];
        if(base.role.id === 3){
            return base.menu.filter(x => controller.find(e => e === x.id))
        }else if(base.role.id === 4){
            return base.menu.filter(x => feedback.find(e => e === x.id))
        }else if(base.role.id === 2){
            return base.menu.filter(x => comun.find(e => e === x.id))
        }else if(base.role.id === 6){
            return base.menu.filter(x => quality.find(e => e === x.id))
        }
        return base.menu;
        */
    },
    getPeriods(base){
        return base.periods
        .filter(p => p.state === '1')
        .sort((a, b) => (a.sorter || 0) - (b.sorter || 0));
    },
    getRoles(base){
        return base.roles.sort((a,b)=>a.id - b.id);
    },
    getAssessments(base){
        return base.assessments;
    }
}

const actions = {
    // Action centralizada para mudança de setor com validação
    async changeSector({ commit, state, dispatch }, sector) {
        // Validação: setor está na lista de acessíveis?
        const hasAccess = state.sectors.some(s => s.id === sector.id);
        
        if (!hasAccess) {
            console.error('Acesso negado ao setor:', sector);
            return false;
        }
        
        // Atualiza setor
        commit('setSector', sector);
        
        // Refiltra menu baseado no novo setor
        await dispatch('filterMenuBySector');
        
        return true;
    },
    
    async filterMenuBySector({ commit, state }) {
        // Importa o serviço dentro da action para evitar problemas de dependência circular
        const optionService = require('../services/optionService').default;
        
        // Verifica se há role e setor definidos
        if (!state.role || !state.role.options || !state.sector || !state.sector.id) {
            commit('setFilteredMenu', []);
            return;
        }

        try {
            // Pega todas as opções permitidas pela role
            const roleOptions = state.role.options || [];
            
            // Para cada opção da role, verifica se o setor tem permissão
            const filteredPromises = roleOptions.map(async (option) => {
                try {
                    const response = await optionService.getOptionSectorEnable(state.sector.id, option.id);
                    
                    // Se não existe resposta (null/undefined), assume que está habilitado (comportamento padrão)
                    if (response.data === null || response.data === undefined) {
                        return option; // Sem configuração específica = habilitado por padrão
                    }
                    
                    // CRÍTICO: Verifica se a resposta é do setor atual
                    // A API pode retornar configuração de outro setor
                    if (response.data.sectorId !== state.sector.id) {
                        return option; // Configuração de outro setor = usa padrão (habilitado)
                    }
                    
                    // Se tem configuração do setor atual e está habilitado, retorna a opção
                    if (response.data.enableAccess) {
                        return option;
                    }
                    
                    // Se está desabilitado, retorna null
                    return null;
                } catch (error) {
                    // Em caso de erro, assume que está habilitado (fail-safe)
                    console.warn(`Erro ao verificar permissão do setor para opção ${option.id}:`, error);
                    return option;
                }
            });

            // Aguarda todas as verificações
            const results = await Promise.all(filteredPromises);
            
            // Remove os nulls (opções desabilitadas)
            const filteredMenu = results.filter(option => option !== null);
            
            // Atualiza o menu filtrado no state
            commit('setFilteredMenu', filteredMenu);
            
        } catch (error) {
            console.error('Erro ao filtrar menu por setor:', error);
            // Em caso de erro geral, usa as opções da role sem filtro
            commit('setFilteredMenu', state.role.options || []);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}